// extracted by mini-css-extract-plugin
module.exports = {"FocusSpace":"Structure_FocusSpace__2iwxg"};